import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ImageGalleryItem } from './image-gallery-item.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-image-gallery',
  imports: [CommonModule, TranslateModule],
  templateUrl: './image-gallery.component.html',
  styleUrl: './image-gallery.component.scss'
})
export class ImageGalleryComponent {
  @Input() images: ImageGalleryItem[] = [];

  public currentImageIndex: number = 0;
  public currentImage: ImageGalleryItem;

  private touchStartX: number = 0;
  private touchEndX: number = 0;
  private minSwipeDistance: number = 50;

  ngOnInit(): void {
    this.selectImage(0);
  }

  selectImage(index: number): void {
    if (index >= 0 && index < this.images.length) {
      this.currentImageIndex = index;
      this.setCurentImage();
    }
  }

  previousImage(): void {
    if (this.currentImageIndex > 0) {
      this.currentImageIndex--;
      this.setCurentImage();
    }
  }

  nextImage(): void {
    if (this.currentImageIndex < this.images.length - 1) {
      this.currentImageIndex++;
      this.setCurentImage();
    }
  }

  onKeydown(event: KeyboardEvent) {
    //console.log(event);
    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        this.nextImage();
        event.preventDefault();
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        this.previousImage();
        event.preventDefault();
        break;
      default:
        break;
    }
  }

  onTouchStart(event: TouchEvent): void {
    this.touchStartX = event.changedTouches[0].screenX;
  }

  onTouchEnd(event: TouchEvent): void {
    this.touchEndX = event.changedTouches[0].screenX;
    this.handleSwipeGesture();
  }

  private handleSwipeGesture(): void {
    const swipeDistance = this.touchEndX - this.touchStartX;
    if (Math.abs(swipeDistance) < this.minSwipeDistance) {
      return;
    }

    if (swipeDistance > 0) {
      this.previousImage();
    } else {
      this.nextImage();
    }
  }

  private mouseStartX: number = 0;
  private mouseEndX: number = 0;
  private isMouseDown: boolean = false;

  onMouseDown(event: MouseEvent): void {
    this.isMouseDown = true;
    this.mouseStartX = event.clientX;
    event.preventDefault();
  }

  onMouseUp(event: MouseEvent): void {
    if (!this.isMouseDown) return;

    this.isMouseDown = false;
    this.mouseEndX = event.clientX;
    this.handleMouseSwipe();
  }

  onMouseLeave(): void {
    this.isMouseDown = false;
  }

  private handleMouseSwipe(): void {
    const swipeDistance = this.mouseEndX - this.mouseStartX;

    if (Math.abs(swipeDistance) < this.minSwipeDistance) {
      return;
    }

    if (swipeDistance > 0) {
      this.previousImage();
    } else {
      this.nextImage();
    }
  }

  private setCurentImage() {
    this.currentImage = this.images[this.currentImageIndex];
  }
}
